export default function AddTooltip(elem, force = false) {
  elem.setAttribute('title', '');

  if (elem.offsetWidth < elem.scrollWidth || force) {
    const title = elem.value || elem.innerHTML;

    elem.setAttribute('title', title);
  }

  return elem;
}
